import { Controller } from 'react-hook-form';
import FieldRow from 'components/FormElements/FieldRow';
import TextField from 'components/FormElements/AppTextInput';
import Spacing from 'components/Spacing';
import Checkbox from '@mui/material/Checkbox';
import { useRolesForOrganisation } from 'hooks/data/adminUser/useOrganisationMemberships';
import { AdminUserRealm } from 'further-types/admin-user';
import { AppSimpleSelect } from 'components/FormElements';

const GeneralInformation = ({
  control,
  errors,
  isAddingCurrentUserToOrganization,
}) => {
  const { data: availableRoles } = useRolesForOrganisation(AdminUserRealm.Lp);

  if (!availableRoles) return null;

  return (
    <Spacing>
      <FieldRow title="Firm name*" centerTitle>
        <Controller
          name="firmName"
          control={control}
          render={({ field: { ref, ...rest } }) => (
            <TextField
              {...rest}
              inputRef={ref}
              placeholder="e.g. Acme Ventures"
              helperText={errors.firmName?.message}
              fullWidth
            />
          )}
        />
      </FieldRow>
      <FieldRow title="Add yourself as a user to this new firm?" centerTitle>
        <Controller
          name="addCurrentUserToOrganization"
          control={control}
          render={({ field: { ref, ...rest } }) => (
            <Checkbox
              {...rest}
              inputRef={ref}
              placeholder="Add yourself as a user"
            />
          )}
        />
      </FieldRow>
      {isAddingCurrentUserToOrganization ? (
        <FieldRow title="Select your role in this firm" centerTitle>
          <Controller
            name="newUserAuth0RoleId"
            control={control}
            render={({ field: { ref, ...rest } }) => (
              <AppSimpleSelect
                fullWidth
                options={availableRoles?.map((role) => ({
                  label: role.name,
                  value: role.auth0RoleId,
                }))}
                {...rest}
                error={!!errors.newUserAuth0RoleId}
                errorMessage={errors.newUserAuth0RoleId?.message}
              />
            )}
          />
        </FieldRow>
      ) : null}
    </Spacing>
  );
};

export default GeneralInformation;
